<template>
  <form novalidate="true" autocomplete="off">
    <slot />
  </form>
</template>

<script>
export default {
  name: "FormValidator",
  data() {
    return {
      elements: []
    };
  },
  computed: {
    mountedElements: function() {
      return this.elements.filter(el => {
        // Filtrar todos los elementos que no estan "destruidos"
        return !el._isDestroyed;
      });
    }
  },
  methods: {
    validate() {
      let validForm = true;

      let primeroEnError = null;

      for (let i = 0; i < this.mountedElements.length; i++) {
        let element = this.mountedElements[i];
        if (!element.checkValid) {
          this.$log.error(
            "No se implementó la función checkValid en el elemento: " +
              element.$options.name
          );
        } else {
          if (!element.checkValid()) {
            if (!primeroEnError) {
              primeroEnError = element;
            }
            validForm = false;
          }
        }
      }

      // Si ya sé que el form no es válido
      if (!validForm && primeroEnError != null) {
        // Scrolleo al primero en error
        primeroEnError.$el.scrollIntoView();
      }

      return validForm;
    },
    subscribe(el) {
      this.elements.push(el);
    }
  }
};
</script>

<style scoped></style>
